<template>
    <!-- 防骗指南 -->
    <!-- 导航栏 -->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>

    <!-- 主体内容容器 -->
    <div class="container errong">
        <div class="container-fluid mt-3">
            <div class="row shengse  mt-2">
                <div class="py-2 d-flex justify-content-between align-items-center">
                    <div class="lf go-back" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
                <div class="p-3 gohome">
                    <div class="rules-card">
                        <div class="rules-title">分佣比例</div>
                        <div class="rules-text">
                            当前为二级分销推广模式，您的分佣比例为： 直接推广 50%, 间接推广 5%
                        </div>

                        <div class="rules-gap"></div>

                        <div class="rules-title">推广规则</div>

                        <div class="rules-list">
                            <p>御凤楼7年老平台，结算稳定，支持多种结算方式！</p>
                            <p>自动开通代理权限，去除繁琐申请流程</p>
                            <p>有任意用户通过您的二维码或推广链接访问本平台</p>
                            <p>在本平台开通任意会员您会获得50%的直推佣金收益。</p>
                            <p>开通月会员，您将获得50￥的佣金收益</p>
                            <p>开通季度会员，您将获得100￥的佣金收益</p>
                            <p>开通年会员，您将获得180￥的佣金收益</p>
                            <p>开通永久至尊会员 您将获得250￥的佣金收益</p>
                            <p>您推广的所有用户将永久与您绑定，后续只要开通会员或者续费会员您都可以获得佣金收益！</p>
                            <p>推广链接以及二维码均做过特殊防封处理，长期有效，无需担心屏蔽问题！</p>
                            <p>平台自有双端原生支付，留存转化率相比于其他平台会高出很多，欢迎各大代理对接测试！</p>
                            <p>
                                当推广佣金达到1000元后，您即可申请佣金提现（支持支付宝/银行卡/ATM存现金以及USDT结算），提现佣金24小时内会处理完毕。
                            </p>
                            <p>推广满50人可以找客服领取专属防封短域名，让你推广更加方便！ 客服邮箱 yufenglou321@gmail.com</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
    <!-- 只是占据空间 -->
    <div class="gongxi2"></div>

    <!-- 公共底部 -->
    <ZhaiFootPC></ZhaiFootPC>
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC"; // 导入导航栏组件
    import ZhaiFootPC from "../componentspc/ZhaiFootPC"; // 导入底部组件

    export default {
        name: "PPromotionRules", // 组件名称
        components: { ZhaiHeadPC, ZhaiFootPC }, // 注册组件
        methods: {
            // ✅ 返回：优先 history.back()，否则跳推广中心页
            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },
        }
    }
</script>

<style scoped>

    body {
        font-family: Arial, sans-serif;
    }

    .gongxi2 {
        height: 20px;
    }
    .lf {
        font-weight: 700;
    }
    .go-back {
        cursor: pointer;
    }
    /* 最大容器的左右内边距 */
    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    /* 文本的样式 */
    .gohome h1 {
        font-size: 1.5rem;
        margin-top: 2rem;
        color: #00c26f;
        padding-left: 15px;
        padding-right: 15px;
    }

    .gohome p {
        font-size: 1rem;
        padding: 1rem 0;
        color: #000;
        line-height: 1.5rem;
        padding-left: 15px;
        padding-right: 15px;
    }


    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 80px; /* 根据导航栏高度调整 */
        }
    }
    /* 白色卡片容器（模拟截图那种白底内容区） */
    .rules-card {
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        padding: 18px 16px;
    }

    /* 标题：加粗、黑色 */
    .rules-title {
        font-size: 18px;
        font-weight: 800;
        color: #111;
        margin-bottom: 10px;
    }

    /* 分佣比例那行说明 */
    .rules-text {
        font-size: 16px;
        color: #666;
        line-height: 26px;
        padding-left: 15px;
    }

    /* 两段之间的空隙 */
    .rules-gap {
        height: 18px;
    }

    /* 规则段落：每条一行，灰色，行距舒服 */
    .rules-list p {
        margin: 0 0 2px 0;
        font-size: 16px;
        color: #666;
        line-height: 0px;
        word-break: break-all;
    }

</style>
